import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: 12,
    backgroundColor: "#fff",
    boxShadow: "0 1px 14px 7px rgba(0,0,0,0.05), 0 1px 3px 0 rgba(0,0,0,0.2)",
    padding: '4em 4.8em',
    position: 'relative',
    [theme.breakpoints.down('xs')]: {
      padding: '3em 1.8em',
    },
    [theme.breakpoints.down('xs')]: {
      padding: '1.6em',
    },
  },
  pageHeading: {
    color: '#000000DE',
    fontFamily: 'Montserrat',
    fontSize: '20px',
    fontWeight: '600',
    letterSpacing: '0.15px',
    lineHeight: '24px',
    paddingBottom: '20px',
    paddingLeft: 12,
    paddingTop: 4
  },
  dialogStyle: {
    borderRadius: '12px !important',
    minWidth: '900px',
    maxHeight: "100%",
    backgroundColor: '#fff',
    position: 'fixed',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '95%',
      minWidth: 'auto'
    }
  },

  header: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
  },

  body: {
    width: '100%',
  },

  rightMenuContainer: {
    display: 'flex',
    textAlign: 'right',
    position: 'absolute',
    top: '20px',
    right: '35px',
    alignItems: 'center'
  },
  PreferredAccount: {
    color: '#76BD1D',
    fontFamily: 'Montserrat',
    fontSize: '14px',
    fontWeight: '500',
    letterSpacing: '0.47px',
    lineHeight: '18px',
    textAlign: 'center',
    width: '210px',
    border: '1px solid #979797',
    borderRadius: '6px',
    backgroundColor: '#FFFFFF',
    textTransform: 'initial',
    height: '33px'
  },

  formContainer: {
    paddingTop: '20px',
    [theme.breakpoints.down('sm')]: {
      padding: '20px 10px 0 10px',
    },
    '& .MuiFormLabel-root': {
      fontFamily: 'Montserrat',
      fontSize: '16px',
      fontWeight: '600',
      letterSpacing: '0.36px',
      lineHeight: '19px',
      background: '#fff',
      paddingRight: '5px'
    },
    '& .MuiFormLabel-root.Mui-focused': {
      // color: prop => prop.secondaryColorCode,
    }
  },

  inputStyle: {
    // color: "#535D6D",
    fontFamily: "Montserrat",
    fontSize: 16,
    fontWeight: "600",
    '&.Mui-checked': {
      // color: prop => prop.secondaryColorCode,
    },
    '& .MuiInputLabel-outlined': {
      // color: '#535D6D',
      fontFamily: 'Montserrat',
      fontSize: '16px',
      fontWeight: '600',
      letterSpacing: '0.36px',
      lineHeight: '19px',
      // background: '#fff'
    },
    '& .MuiOutlinedInput-notchedOutline': {
      // borderColor: '#535D6D'
    },
    '& .Mui-focused.MuiInputLabel-outlined': {
      // color: prop => prop.secondaryColorCode,
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      // borderColor: prop => prop.secondaryColorCode,
    },
    '& .MuiSelect-select': {
      // color: '#535D6D',
      fontFamily: 'Montserrat',
      fontSize: '16px',
      fontWeight: '600',
      letterSpacing: '0.36px',
      lineHeight: '19px'
    },
    '&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      // borderColor: prop => prop.secondaryColorCode,
    }
  },

  accRadioType: {
    color: '#000000',
    fontFamily: 'Montserrat',
    fontWeight: 500,
    fontSize: 16,
    letterSpacing: '0.44px',
    lineHeight: '1.3em',
  },

  radioBtn: {
    '& .Mui-checked': {
      color: "#535D6D",
    },
    '& .MuiFormControlLabel-label': {
      color: '#000000',
      fontFamily: 'Montserrat',
      fontSize: '16px',
      fontWeight: '600',
      letterSpacing: '0.53px',
      lineHeight: '19px',
    }
  },

  checkboxColorCode: {
    color: "#535D6D !important",
  },

  checkImg: {
    width: '474px',
    height: '154px',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      height: '100%'
    },
  },

  bankImg: {
    width: '26px',
    height: '26px'
  },

  cancelAccButton: {
    fontFamily: 'Montserrat',
    letterSpacing: '0.36px',
    fontWeight: '600',
    marginRight: '25px',
    width: '180px',
    border: '2px solid',
    borderColor: theme.palette.primary.main,
    boxShadow: "0 2px 2px 0 rgba(0,0,0,0.14), 0 3px 1px -2px rgba(0,0,0,0.12), 0 1px 5px 0 rgba(0,0,0,0.2)",

    [theme.breakpoints.down('xs')]: {
      marginBottom: '28px',
      marginRight: 0,
    },
  },

  addAccButton: {
    width: '180px',
    fontFamily: 'Montserrat',
    fontWeight: '600',
    textTransform: 'uppercase'
  },
  buttonContainer: {
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
  checkboxItem: {
    display: 'flex',
    alignItems: 'center',
    color: '#535D6D',
    fontFamily: 'Montserrat',
    fontSize: '16px',
    letterSpacing: '0.36px',
    lineHeight: '19px',
    marginLeft: '0.3em',
    '& svg': {
      marginRight: '0.3em'
    }
  },
  checkboxSaveAccount: {
    display: 'flex',
    alignItems: 'center',
    color: '#535D6D',
    fontFamily: 'Montserrat',
    fontSize: '16px',
    letterSpacing: '0.36px',
    lineHeight: '19px',
    marginLeft: '0.3em',
    '& svg': {
      marginRight: '0.3em'
    }
  },
  errorMsg: {
    fontSize: '1.4em',
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: 10,
    marginTop: 5,
    fontFamily: 'Montserrat',
    color: "red",
  },
  dataLoader: {
    width: '100px',
    height: '100px',
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    display: 'block',
    margin: '0 auto',
    zIndex: '999',
  },
  loaderRoot: {
    width: '100%',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
 
  abaError: {
    color: 'red',
    fontFamily: 'Montserrat',
    fontSize: '0.75rem',
    fontWeight: '600',
    letterSpacing: '0.53px',
    lineHeight: '14px',
    marginTop: 6,
    marginLeft: 14
    // cursor: 'pointer'
  },

  iconStyle: {
    position: 'absolute',
    right: '20px',
    top: '20px',
    cursor: 'pointer',
    padding: 0,
    color: '#535D6D',
    fontSize: '24px'
  },

  aBaBankDetails: {
    color: '#000000',
    fontFamily: 'Montserrat',
    fontSize: '14px',
    fontWeight: '600',
    letterSpacing: '0.53px',
    lineHeight: '14px',
    marginTop: 6,
    paddingLeft: 14
  },

  padding0: {
    [theme.breakpoints.down('sm')]: {
      padding: '0 20px !important'
    },
  },

  validateRLoader: {
    height: '25px', width: '25px', position: 'absolute', right: '12px', top: '10px'
  }

}));

